export default function themeNavigation(themeData) {
  // default menu class to show if no theme is found
  const defaultMenuClass = 'douglas-fairgrounds';
  // Body class for the Fair theme
  const fairBodyClass = 'douglas-county-fair';

  // Find the li.group element in the nav that matches the theme name
  function hideNavigationGroup() {
    const group = $('#mainNavigation .group');

    group.each(function () {
      const groupItem = $(this);
      const matchingTheme = themeData.find((theme) =>
        groupItem.children().first().text().includes(theme.name),
      );

      if (matchingTheme?.classBody === fairBodyClass) {
        groupItem.addClass(matchingTheme.classBody + '-menu');
      } else {
        groupItem.addClass(defaultMenuClass);
      }
    });
  }

  // Apply the navigation structure for the current theme if its class exists on the body
  function applySubpageNavigation() {
    if (!$('body').hasClass(fairBodyClass)) return;

    const fairTheme = themeData.find((theme) => theme.classBody === fairBodyClass);

    if (fairTheme) {
      const $fairMenu = $(`.${fairBodyClass}-menu`);
      $(`.${defaultMenuClass}`).remove();
      createMenu($fairMenu);
      $fairMenu.show();
    }
  }

  hideNavigationGroup();
  applySubpageNavigation();
}

// Create the menu structure
function createMenu($menu) {
  const $groups = $($menu).find('.items');
  const $mainNavigationUL = $('#mainNavigation ul.groups');

  // append the new menu structure to the main navigation
  $mainNavigationUL.last().after($groups);
  // remove the default menu structure
  $mainNavigationUL.first().remove();
  // create the new menu structure
  createFirstLevel($groups);
}

// firstLevel replace the class 'items' with 'groups' to create the outer dropdown
function createFirstLevel($menu) {
  $menu.removeClass('items').addClass('groups');
  const $firstLevelList = $menu.children();
  $firstLevelList.first().remove();
  $firstLevelList.each(function () {
    const $group = $(this);
    $group.removeClass('item').addClass('group');
    if ($group.children().length > 1) {
      createSecondLevel($group);
    }
  });
}

// secondLevel replace the class 'subitems' with 'items' to create the inner dropdown
function createSecondLevel($group) {
  const $secondLevelList = $group.children();

  if ($secondLevelList.length > 1) {
    $secondLevelList.each(function () {
      const $item = $(this);
      // if item has class 'subitem' remove it
      if ($item.hasClass('subitems')) {
        $item.removeClass('subitems');
        $item.addClass('items');
      }
    });
  }
}
